<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-12 cf-text-align-left">
    <div class="cf-flex cf-flex--column cf-flex--gap-8">
      <div
        v-for="p in payment.payments"
        :key="p.id"
        class="cf-flex cf-flex--column cf-flex--gap-8"
      >
        <!-- Offer Redemption Payment -->
        <p
          v-if="p.paymentType === 'Offer'"
          class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy"
        >
          {{ discountNames }}
        </p>

        <!-- Room Charge -->
        <p
          v-else-if="p.paymentType === 'RoomCharge'"
          class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy"
        >
          Charged to Room
        </p>

        <!-- In Store Payment -->
        <div
          v-else-if="p.paymentType === 'InStore'"
          class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-12"
        >
          <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
            In Store
          </p>

          <p class="cf-subtitle cf-subtitle--2">
            {{ getPaymentAmountDisplay(p) }}
          </p>
        </div>

        <!-- Credit Card Payment -->
        <template v-else>
          <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-12">
            <card-type-icon
              :card-type="p.cardType"
              :payment-type="p.paymentType"
            />

            <h4
              v-if="p.cardNumberLastFour"
              class="cf-title cf-title--4"
            >
              <span>
                ••••
              </span>

              <span>
                {{ p.cardNumberLastFour }}
              </span>
            </h4>

            <p
              v-if="!!payment.payments.length"
              class="cf-subtitle cf-subtitle--2"
            >
              {{ getPaymentAmountDisplay(p) }}
            </p>
          </div>

          <p
            v-if="p.paymentType === 'GiftCard' && (p.giftCardRemainingBalance || p.giftCardRemainingBalance === 0)"
            class="cf-subtitle cf-subtitle--2"
          >
            Remaining Balance: {{ $dollars(p.giftCardRemainingBalance) }}
          </p>
        </template>
      </div>

      <!-- Transaction Date & Time -->
      <p
        v-if="payment.transactionDateTime"
        class="cf-subtitle cf-subtitle--2"
      >
        <template v-if="order.store">
          {{ $moment(payment.transactionDateTime, 'MMM Do, YYYY h:mm A', order.store.timeZone) }}
        </template>

        <template v-else>
          {{ $moment(payment.transactionDateTime, 'MMM Do, YYYY h:mm A') }}
        </template>
      </p>
    </div>

    <cf-receipt-from-location-details
      v-if="displayStoreLocation"
      :store="order.store"
    />
  </div>
</template>


<script>
  import dollars from '@/filters/dollars';

  import CfReceiptFromLocationDetails from '@/view/components/globals/cf-receipt-from-location-details/index.vue';

  export default {
    name: 'CfYourPayment',

    components: {
      CfReceiptFromLocationDetails
    },

    props: {
      isPending: {
        type: Boolean,
        default: false
      },

      order: {
        type: Object,
        default() {
          return {
            offers: []
          };
        }
      },

      payment: {
        type: Object,
        required: true
      },

      displayStoreLocation: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      discountNames() {
        const names = [];

        this.order.offers.forEach((offer) => {
          const name = offer.name || offer.promotionCode;

          if (name) {
            names.push(name);
          }
        });

        return names.join(', ');
      }
    },

    methods: {
      getPaymentAmountDisplay(payment) {
        let totalString = `(${dollars(payment.amount)}`;

        if (payment.surcharge) totalString += ` + ${dollars(payment.surcharge)}`;

        totalString += ')';

        return totalString;
      }
    }
  };
</script>
